import { Toaster } from '@/components/ui/sonner';
import { useTelegramViewport } from '@/hooks/use-telegram-viewport';
import { isDevMode } from '@/lib/is-dev-mode';
import AuthProvider from '@/providers/auth-provider';
import SocketProvider from '@/providers/socket-provider';
import { useEffect } from 'react';
import { Outlet } from 'react-router';

function App() {
	useTelegramViewport();

	useEffect(() => {
		if (isDevMode) return;

		setTimeout(() => {
			window.Telegram.WebApp.ready();
			window.Telegram.WebApp.expand();
			window.Telegram.WebApp.setHeaderColor('#0a0a0a');
			window.Telegram.WebApp.setBottomBarColor('#0a0a0a');
			window.Telegram.WebApp.setBackgroundColor('#0a0a0a');
			window.Telegram.WebApp.lockOrientation();
		}, 100);
	}, []);

	return (
		<div className='h-app w-full max-w-[460px] mx-auto flex flex-col min-h-0 overflow-hidden scrollbar-hide motion-safe'>
			<Toaster position='bottom-center' duration={2000} />
			<AuthProvider>
				<SocketProvider>
					<Outlet />
				</SocketProvider>
			</AuthProvider>
		</div>
	);
}

export default App;
